// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3827
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";
import type { ActionSurfaceComponent } from "../enums/action_surface_component";
import type { FeatureLine } from "../enums/feature_line";

// Event_name: 'click.stack_chat'
// Description: - Found in the header actions of the Stack Detail page.
// - Disabled when there are no summarizable documents in the Stack
// - Clicking the button will start a new Stack Chat with the summarizable documents (and no pre-populated query). Or the Try asking component only appears when there is at least one summarizable document in the Stack.
// Owner: dash-web
export type Click_StackChat = PAPEventGeneric<
  'dash',
  'click',
  'stack_chat',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // The component within a surface in which an action was taken on Dash.
    actionSurfaceComponent?: ActionSurfaceComponent;
    // Feature Line for dash
    featureLine?: FeatureLine;
    // The stack id that represents the stack (without extra hashing on the client side)
    unhashedStackId?: string;
    // marks if the content is shared content
    isShared?: boolean;
    // Answers if the event actor on the stack is the same as the creator of the stack
    isOwner?: boolean;
    // Whether the user is interacting with their welcome stack
    isWelcomeStack?: boolean;
  }
>;

export function PAP_Click_StackChat(properties?: Click_StackChat['properties']): Click_StackChat {
  return <Click_StackChat>{
    class: 'dash',
    action: 'click',
    object: 'stack_chat',
    properties,
  };
}
